<div
	class="color-palette-editor"
	[ngClass]="mode === 'inline' ? 'inline-mode' : 'offcanvas-mode'"
>
	<!-- Inline Mode -->
	@if (mode === "inline") {
		@if (!hideCloseButton) {
			<div class="inline-header">
				<button
					type="button"
					class="btn-close btn-sm"
					aria-label="Close"
					(click)="closeInlineEditor()"
				></button>
			</div>
		}

		@if (editablePalette) {
			<!-- Other Colors -->
			<div class="color-list other-colors-section">
				@for (field of colorFields; track field.purpose) {
					<div
						class="color-row"
						(click)="!readonly && triggerColorPicker($event)"
					>
						<div class="color-picker-wrapper position-relative">
							<input
								type="color"
								class="color-picker"
								[value]="getColorValue(field.purpose)"
								(change)="
									onColorPickerChange(field.purpose, $event)
								"
								[disabled]="readonly"
							/>
							<div
								class="color-swatch-small"
								[style.background-color]="
									getColorValue(field.purpose)
								"
								[class.clickable]="!readonly"
							></div>
						</div>
						<span class="color-label-small"
							>{{ field.label }}

							@if (
								showResetIndicators &&
								colorDiffersFromReference(field.purpose)
							) {
								<button
									type="button"
									class="reset-indicator border-0 p-0 bg-transparent"
									style="cursor: pointer"
									(click)="
										onResetClick(field.purpose, $event)
									"
									title="Palauta oletusväri"
								>
									<i class="bi bi-arrow-counterclockwise"></i>
								</button>
							}
						</span>
					</div>
				}
			</div>

			<!-- Hidden colors message (only in inline mode) -->
			<!-- @if (mode === "inline" && hiddenColorsCount > 0) {
				<div class="text-muted text-small mt-2">
					<i class="bi bi-info-circle me-1"></i>
					+{{ hiddenColorsCount }} väriä.
				</div>
			} -->
		} @else {
			<div class="alert alert-warning">
				<i class="bi bi-exclamation-triangle me-2"></i>
				Ei väripalettia muokattavana.
			</div>
		}
	}

	<!-- Offcanvas Mode -->
	@if (mode === "offcanvas") {
		<!-- Offcanvas Header -->
		@if (!hideHeader) {
			<div class="offcanvas-header">
				<h5 class="offcanvas-title d-flex align-items-center gap-2">
					<i class="bi bi-palette-fill"></i>
					Muokkaa väripalettia
					@if (editablePalette?.name) {
						<span class="text-muted"
							>- {{ editablePalette.name }}</span
						>
					}
				</h5>
				<button
					type="button"
					class="btn-close"
					aria-label="Close"
					(click)="closeOffcanvas()"
				></button>
			</div>
		}

		<!-- Offcanvas Body -->
		<div class="offcanvas-body" [class.pt-0]="hideHeader">
			@if (editablePalette) {
				<!-- Primary Colors (always visible) -->
				<div class="row g-3 mb-3">
					@for (field of primaryColors; track field.purpose) {
						<div class="col-12 col-md-6">
							<div class="color-field-editor">
								<label
									class="form-label d-flex align-items-center gap-2 text-small"
								>
									{{ field.label }}
									@if (field.required) {
										<span class="text-danger">*</span>
									}
								</label>

								<div class="color-input-group">
									<!-- Color preview and picker -->
									<div
										class="color-picker-wrapper position-relative"
									>
										<input
											type="color"
											class="color-picker"
											[value]="
												getColorValue(field.purpose)
											"
											(change)="
												onColorPickerChange(
													field.purpose,
													$event
												)
											"
											[disabled]="readonly"
										/>
										<div
											class="color-preview"
											[style.background-color]="
												getColorValue(field.purpose)
											"
											(click)="
												!readonly &&
													triggerColorPicker($event)
											"
											[class.clickable]="!readonly"
										></div>
										@if (
											showResetIndicators &&
											colorDiffersFromReference(
												field.purpose
											)
										) {
											<button
												type="button"
												class="reset-indicator position-absolute border-0 p-0 bg-transparent"
												style="
													top: -4px;
													right: -4px;
													cursor: pointer;
												"
												(click)="
													onResetClick(
														field.purpose,
														$event
													)
												"
												title="Palauta oletusväri"
											>
												<span
													class="badge rounded-circle bg-warning"
													style="
														width: 10px;
														height: 10px;
														display: block;
													"
												></span>
											</button>
										}
									</div>

									<!-- Hex input -->
									<input
										type="text"
										class="form-control hex-input"
										[value]="getColorValue(field.purpose)"
										(input)="
											onHexInputChange(
												field.purpose,
												$event
											)
										"
										[readonly]="readonly"
										placeholder="#000000"
										maxlength="7"
										pattern="^#([0-9A-F]{3}|[0-9A-F]{6})$"
										title="Anna väri heksadesimaalimuodossa (esim. #FF5733)"
									/>
								</div>
							</div>
						</div>
					}
				</div>

				<!-- Other Colors -->
				<div class="row g-3 other-colors-section">
					@for (field of otherColors; track field.purpose) {
						<div class="col-12 col-md-6">
							<div class="color-field-editor">
								<label
									class="form-label d-flex align-items-center gap-2 text-small"
								>
									{{ field.label }}
									@if (field.required) {
										<span class="text-danger">*</span>
									}
								</label>

								<div class="color-input-group">
									<!-- Color preview and picker -->
									<div
										class="color-picker-wrapper position-relative"
									>
										<input
											type="color"
											class="color-picker"
											[value]="
												getColorValue(field.purpose)
											"
											(change)="
												onColorPickerChange(
													field.purpose,
													$event
												)
											"
											[disabled]="readonly"
										/>
										<div
											class="color-preview"
											[style.background-color]="
												getColorValue(field.purpose)
											"
											(click)="
												!readonly &&
													triggerColorPicker($event)
											"
											[class.clickable]="!readonly"
										></div>
										@if (
											showResetIndicators &&
											colorDiffersFromReference(
												field.purpose
											)
										) {
											<button
												type="button"
												class="reset-indicator position-absolute border-0 p-0 bg-transparent"
												style="
													top: -4px;
													right: -4px;
													cursor: pointer;
												"
												(click)="
													onResetClick(
														field.purpose,
														$event
													)
												"
												title="Palauta oletusväri"
											>
												<span
													class="badge rounded-circle bg-warning"
													style="
														width: 10px;
														height: 10px;
														display: block;
													"
												></span>
											</button>
										}
									</div>

									<!-- Hex input -->
									<input
										type="text"
										class="form-control hex-input"
										[value]="getColorValue(field.purpose)"
										(input)="
											onHexInputChange(
												field.purpose,
												$event
											)
										"
										[readonly]="readonly"
										placeholder="#000000"
										maxlength="7"
										pattern="^#([0-9A-F]{3}|[0-9A-F]{6})$"
										title="Anna väri heksadesimaalimuodossa (esim. #FF5733)"
									/>
								</div>
							</div>
						</div>
					}
				</div>

				@if (readonly) {
					<div class="alert alert-info mt-3 mb-0">
						<i class="bi bi-info-circle me-2"></i>
						Tämä väripaletti on vain lukutilassa.
					</div>
				}
			} @else {
				<div class="alert alert-warning">
					<i class="bi bi-exclamation-triangle me-2"></i>
					Ei väripalettia muokattavana.
				</div>
			}
		</div>
		<!-- End offcanvas-body -->
	}
</div>
